// dashboardTokens.js
// Shared visual constants for ASPIREdeck dashboard-family pages
// (Dashboard, DashboardEnrich, CareerDashboard, CoachTheCoachDashboard, LeadershipDashboard)
//
// Goal: stop radius/spacing/type values being picked ad-hoc per inline style.
// Import and use these instead of hardcoding pixel values in JSX.

export const radius = {
  sm: "8px",   // buttons, inputs, icon buttons, account rows
  lg: "16px",  // modal panels, cards, chosen-subject box
  pill: "999px", // tags, tab pills, status badges
};

export const spacing = {
  xs: "6px",
  sm: "10px",
  base: "14px",
  md: "20px",
  lg: "28px",
  xl: "40px",
};

export const fontSize = {
  xs: "12px",   // meta text, timestamps, helper captions
  sm: "13px",   // secondary labels, subtitles
  base: "14px", // body text, buttons
  md: "16px",   // section labels
  lg: "20px",   // card titles
  xl: "28px",   // page/modal headings
};

export const color = {
  // Primary action (blue) — buttons, links, active states
  primary: "#028be8",
  primaryLight: "#36a7f8",
  primaryGlow: "#00e1ff",

  // Accent (amber) — reserved for icon-affordance actions only
  // (compass / RSS / note-edit). Do not reuse for warnings.
  accent: "#ffaa00",

  // Warning / caution — cooldowns, restricted actions, locked states
  warning: "#fbbf24",
  warningBg: "rgba(255, 193, 7, 0.12)",
  warningBorder: "rgba(255, 193, 7, 0.35)",

  // Danger — delete, disconnect, irreversible actions
  danger: "#ff6666",
  dangerBg: "rgba(255, 102, 102, 0.1)",
  dangerBorder: "rgba(255, 102, 102, 0.3)",

  // Success — confirmations, completed states
  success: "#4ade80",
  successBg: "rgba(74, 222, 128, 0.1)",

  // Surfaces
  bgPanel: "#0b1021",
  bgPanelAlt: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
  border: "rgba(255, 255, 255, 0.08)",
  borderStrong: "rgba(255, 255, 255, 0.15)",

  // Text
  textPrimary: "#eee",
  textSecondary: "#9aa4bd",
  textMuted: "#888",
};

export const gradientBorder = {
  // Used by AI-Era-relevance style buttons and Mastery cards.
  // backgroundImage/backgroundOrigin/backgroundClip must be applied together.
  backgroundImage: `linear-gradient(${color.bgPanel}, ${color.bgPanel}), linear-gradient(90deg, ${color.primaryGlow}, ${color.primary})`,
  backgroundOrigin: "border-box",
  backgroundClip: "padding-box, border-box",
  border: "2px solid transparent",
};

export const transition = {
  fast: "0.15s ease",
  base: "0.2s ease",
  slow: "0.35s ease",
};